import { render, staticRenderFns } from "./SingleLayerAttributesInfos.vue?vue&type=template&id=964c332a&scoped=true"
import script from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerAttributesInfos.vue?vue&type=style&index=0&id=964c332a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c332a",
  null
  
)

export default component.exports